import { createIcon } from '../utility/createIcon';

export const IconSortable = createIcon('sortable');

export const IconSortAscending = createIcon('sort-ascending');

export const IconSortDescending = createIcon('sort-descending');
